module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/institutions/create-institution/create-institution.component.css
// module id = ./src/app/components/institutions/create-institution/create-institution.component.css
// module chunks = main